var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wealth-rule"},[_c('img',{attrs:{"src":require("../assets/images/wealth-rule.png")}})])
}]

export { render, staticRenderFns }